export default "__VITE_ASSET__BL2ZGyaW__"